import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../API/apiServices";
import credential from "../../API/Credentials.json";
const apiMethod = credential?.request?.post;
export const submitSignupUser = createAsyncThunk(
  "signup/submitSignupUser",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.SignUp_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apiData);

      if (response && response.success) {
        return response;
      } else {
        return rejectWithValue(response.message);
      }
    } catch (error) {
      rejectWithValue(error.message);
    }
  }
);

export const sendOtpUser = createAsyncThunk(
  "signup/sendOtpUser",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.SendOtp_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apiData);

      if (response && response.success) {
        return response;
      } else {
        return rejectWithValue(response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const phoneOtpUser = createAsyncThunk(
  "signup/phoneOtpUser",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.PhoneOtp_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apiData);

      if (response && response.success) {
        return response;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const SignupSlice = createSlice({
  name: "signup",
  initialState: {
    countryCode: "+1 (US)",
    countryName: "United States",
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    setCountryName: (state, action) => {
      state.countryName = action.payload;
    },
    setCountryCode: (state, action) => {
      state.countryCode = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitSignupUser.pending, (state) => {
        state.loading = true;
        state.signupError = null;
        state.success = false;
      })
      .addCase(submitSignupUser.fulfilled, (state) => {
        state.loading = false;
        state.signupError = null;
        state.success = true;
      })
      .addCase(submitSignupUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(sendOtpUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(sendOtpUser.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(sendOtpUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(phoneOtpUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(phoneOtpUser.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(phoneOtpUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});
export const { setCountryName, setCountryCode } = SignupSlice.actions;
export default SignupSlice.reducer;